import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import { useAppSelector } from "redux/hooks";
import { getNotificationMessage } from "redux/pages/Dashboard/UserMenu/NotificationMessageSlice";

const DISMISSED_KEY = "notificationDismissed";

const fingerprint = (id: number, message: string): string => {
  let hash = 0;
  const str = String(id) + message;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash = hash & hash;
  }
  return String(hash);
};

const NotificationModal: React.FC = () => {
  const dispatch = useDispatch();
  const notificationMessage = useAppSelector((state: any) => state.notificationMessage.notificationMessage);

  const [acknowledged, setAcknowledged] = useState(false);
  const [visible, setVisible] = useState(false);
  const [displayedMessage, setDisplayedMessage] = useState<string>("");
  const [displayedId, setDisplayedId] = useState<number | null>(null);

  useEffect(() => {
    dispatch(getNotificationMessage() as any);
  }, [dispatch]);

  useEffect(() => {
    if (!notificationMessage?.message || !notificationMessage?.notificationId) return;

    const currentFp = fingerprint(notificationMessage.notificationId, notificationMessage.message);
    if (localStorage.getItem(DISMISSED_KEY) === currentFp) return;

    setDisplayedMessage(notificationMessage.message);
    setDisplayedId(notificationMessage.notificationId);
    setAcknowledged(false);
    setVisible(true);
  }, [notificationMessage]);

  const handleClose = () => {
    if (!acknowledged || displayedId === null) return;
    localStorage.setItem(DISMISSED_KEY, fingerprint(displayedId, displayedMessage));
    setVisible(false);
  };

  const renderFooter = () => (
    <Button
      label="OK"
      className="submit-btn"
      disabled={!acknowledged}
      onClick={handleClose}
      autoFocus
    />
  );

  return (
    <Dialog
      header={<span style={{ color: "#009999", fontWeight: 600 }}>Notice</span>}
      visible={visible}
      onHide={handleClose}
      style={{ width: "45vw" }}
      footer={renderFooter()}
      className="delete-modal"
      closable={false}
    >
      <div
        className="notification-message-content"
        style={{ maxHeight: "55vh", overflowY: "auto", paddingRight: "0.25rem" }}
        dangerouslySetInnerHTML={{ __html: displayedMessage }}
      />
      <div className="field-checkbox mt-3 pt-3" style={{ borderTop: "1px solid #dee2e6" }}>
        <Checkbox
          inputId="notif-ack"
          checked={acknowledged}
          onChange={(e) => setAcknowledged(e.checked ?? false)}
        />
        <label htmlFor="notif-ack" className="ms-2">
          I acknowledge that I have read and understood the contents listed
        </label>
      </div>
    </Dialog>
  );
};

export default NotificationModal;
